import { TableStandard } from "ui"
import { Box } from "@mui/material"
import { GridColDef, GridRowModel } from "@mui/x-data-grid"
import { SessionAdventureStats } from "../GlobalOverViewPage"
import { useEffect, useState } from "react"
const COLUMNS: GridColDef[] = [

    {
        field: "adventureName", headerName: "Adventure", flex: 1
    },
    { field: "totalTimeSpent", headerName: "Average Time Spent", flex: 1 }
]
const toSeconds = (t?: string | null) => {
    if (!t) return 0;
    const [h, m, s] = t.split(":").map(Number);
    return h * 3600 + m * 60 + s;
};
const mapAdventureAverages = (sessions: any[]) => {
    const map = new Map<string, any>();

    sessions.forEach((s) => {
        let adventureName = s.adventure;
        let adventureId = s.adventureId;
        if (!adventureName) {
            adventureName = "Unknown"
            adventureId = "UnknownId"
        };

        if (!map.has(adventureName)) {
            map.set(adventureName, {
                adventureId: adventureId,
                adventureName,
                totalTimeSum: 0,
                activeTimeSum: 0,
                count: 0,
            });
        }

        const entry = map.get(adventureName);

        entry.totalTimeSum += toSeconds(s.totalTimeSpent);
        entry.activeTimeSum += toSeconds(s.activeTimeInSurvey);
        entry.count += 1;
    });

    return Array.from(map.values()).map((x) => ({
        id: x.adventureId,
        adventureName: x.adventureName,
        avgTotalTimeSpent: x.count ? x.totalTimeSum / x.count : 0,
        avgActiveTimeSpent: x.count ? x.activeTimeSum / x.count : 0,
    }));
};
const AdventureStatsTable = ({ sessionTypeData }: { sessionTypeData: SessionAdventureStats[] }) => {
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[]
    }>({
        columns: [],
        rows: []
    })
    useEffect(() => {
        if (sessionTypeData.length > 0) {
            setPageTableState((prevState) => {
                const columns = [...COLUMNS]
                const rows = mapAdventureAverages(sessionTypeData);
                console.log("the rows: ", rows)
                return {
                    ...prevState,
                    columns,
                    rows
                }
            })
        }
    }, [sessionTypeData])
    return (
        <Box sx={{ width: "100%" }}>
            <TableStandard
                columns={pageTableState.columns}
                loading={false}
                disableBoxShadow
                rows={pageTableState.rows} />
        </Box>
    )
}

export default AdventureStatsTable